// Lightweight extent helpers for culling off-screen map features. The map view
// is geographic (useGeographic()), so extents are [minLon, minLat, maxLon, maxLat].

export type Extent = [number, number, number, number];

/** Grows an extent outward by `factor` of its width/height on each side. */
export function padExtent(extent: Extent, factor: number): Extent {
  const padX = (extent[2] - extent[0]) * factor;
  const padY = (extent[3] - extent[1]) * factor;
  return [extent[0] - padX, extent[1] - padY, extent[2] + padX, extent[3] + padY];
}

export function pointInExtent(point: number[], extent: Extent): boolean {
  const x = point[0]!;
  const y = point[1]!;
  return x >= extent[0] && x <= extent[2] && y >= extent[1] && y <= extent[3];
}

/** Bounding box of a coordinate ring, or null when the ring is empty. */
export function ringExtent(ring: number[][]): Extent | null {
  if (ring.length === 0) return null;
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  for (const coordinate of ring) {
    const x = coordinate[0]!;
    const y = coordinate[1]!;
    if (x < minX) minX = x;
    if (y < minY) minY = y;
    if (x > maxX) maxX = x;
    if (y > maxY) maxY = y;
  }
  return [minX, minY, maxX, maxY];
}

export function extentsIntersect(a: Extent, b: Extent): boolean {
  return a[0] <= b[2] && a[2] >= b[0] && a[1] <= b[3] && a[3] >= b[1];
}
